import { useEffect, useMemo, useState } from "react"

import useStrings from "../localization/useStrings"

interface CountdownParams {
  endDateSeconds?: number
  maxSeconds?: number
}

const useCountdown = (params: CountdownParams) => {
  const now = Math.ceil(Date.now() / 1000)

  const [forceRefresh, setForceRefresh] = useState(0)
  const strings = useStrings()

  const countdownStart = useMemo(() => {
    return Math.ceil(Date.now() / 1000)
  }, [])

  useEffect(() => {
    const updateForceRefresh = () => {
      setForceRefresh(Math.random())
    }

    const interval = setInterval(updateForceRefresh, 1000)
    return () => clearInterval(interval)
  }, [params.endDateSeconds])

  let remainingSeconds = 0

  if (params.endDateSeconds != null) {
    remainingSeconds = Math.max(params.endDateSeconds - now, 0)
  } else {
    const diff = now - countdownStart

    const promoRemaining = params.maxSeconds ?? 0

    remainingSeconds = Math.max(promoRemaining - diff, 0)
  }

  const seconds = remainingSeconds % 60
  const minutes = Math.floor(remainingSeconds / 60) % 60
  const hours = Math.floor(remainingSeconds / 60 / 60)

  const hourUnit = hours === 1 ? strings.hour : strings.hours
  const minuteUnit = minutes === 1 ? strings.minute : strings.minutes
  const secondUnit = seconds === 1 ? strings.second : strings.seconds

  return {
    seconds,
    minutes,
    hours,
    totalSeconds: remainingSeconds,
    hourUnit,
    minuteUnit,
    secondUnit,
  }
}

export default useCountdown
